import AdminDashboard from "@/pages/AdminDashboard";
import { productApi } from "@/lib/api";
import { ProductModeBanner } from "@/components/ProductModeBanner";

export default function ProductDashboard() {
  return (
    <div data-testid="product-dashboard-page">
      <ProductModeBanner className="mx-4 md:mx-6 mt-4" />
      <AdminDashboard api={productApi} isProduct />
    </div>
  );
}
